import { render, staticRenderFns } from "./CustomTagsInput.vue?vue&type=template&id=68cf009f&"
import script from "./CustomTagsInput.vue?vue&type=script&lang=js&"
export * from "./CustomTagsInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomTagsInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports